import { None, Option } from "@siteimprove/alfa-option";
/**
 * @public
 */
export class Declaration {
    static of(name, value, important = false) {
        return new Declaration(name, value, important);
    }
    _name;
    _value;
    _important;
    /**
     * @remarks
     * If the declaration is in a style rule, point to it
     */
    _parent = None;
    /**
     * @remarks
     * If the declaration is in a style attribute on an element, point to it
     *
     * @remarks
     * "owner" use the same vocabulary as attribute's owner
     *
     * @remarks
     * Only one of _parent and _owner should be Some.
     */
    _owner = None;
    constructor(name, value, important) {
        this._name = name;
        this._value = value;
        this._important = important;
    }
    get name() {
        return this._name;
    }
    get value() {
        return this._value;
    }
    get important() {
        return this._important;
    }
    get parent() {
        return this._parent;
    }
    get owner() {
        return this._owner;
    }
    *ancestors() {
        for (const parent of this._parent) {
            yield parent;
            yield* parent.ancestors();
        }
    }
    /**
     * Parent rule or owner element are ignored for declaration equality.
     */
    equals(value) {
        return (value instanceof Declaration &&
            value._name === this._name &&
            value._value === this._value &&
            value._important === this._important);
    }
    toJSON() {
        return {
            name: this._name,
            value: this._value,
            important: this._important,
        };
    }
    toString() {
        return `${this._name}: ${this._value}${this._important ? " !important" : ""}`;
    }
    /**
     * @internal
     */
    _attachParent(parent) {
        if (this._parent.isSome() || this._owner.isSome()) {
            return false;
        }
        this._parent = Option.of(parent);
        return true;
    }
    /**
     * @internal
     */
    _attachOwner(owner) {
        if (this._parent.isSome() || this._owner.isSome()) {
            return false;
        }
        this._owner = Option.of(owner);
        return true;
    }
}
/**
 * @public
 */
(function (Declaration) {
    function from(json) {
        return Declaration.of(json.name, json.value, json.important);
    }
    Declaration.from = from;
})(Declaration || (Declaration = {}));
//# sourceMappingURL=declaration.js.map